<template lang="pug">
include /@ibkr/lib.common/src/icon/arrow
include /@ibkr/lib.common/src/icon/ui

div(class="s12 insety-16 border-bottom")
    div(class="after-16 before-8", :class="{'flex-flex' : $media.l}")
        div(class="text-semibold mf-label") {{ $t('fund_family') }}
        div(:class="$media.l? 'start-32' : 'before-16'")
            SelectDrop(
                ref="selectDrop"
                class="fund-fields",
                :class="{ 'after-16': !isZenith, '_err': hasError }",
                :options="fundFamilies",
                :defaultValue="defaultFundFamily",
                filterFor="family",
                @getSelect="showFundFamily")
            div(v-if="hasError")
                span.end-4._err-icon
                    +icon-ui-error_filled
                span._err-message {{ $t('please_select_fund_family') }}
</template>

<script>
    import { mapState, mapGetters } from 'vuex'
    import api from '../api/'
    import SelectDrop from './SelectDrop.vue'

    export default {
        name: 'FundFamily',

        components: {
            SelectDrop
        },

        computed: {
            ...mapState('fundscanner', [
                'urlFilters'
            ]),

            ...mapGetters(['isZenith']),

            defaultFundFamily() {
                return this.initializeData();
            }
        },

        data() {
            return {
                fundFamilies: ['All'],
                selected: this.isZenith ? this.$t('filter_by_fund_family') : 'All',
                hasError: false
            }
        },

        methods: {
            showError(data) {
                this.hasError = data;
            },

            getFundFamilies() {
                api.getFundFamilies()
                    .then(res => {
                        this.fundFamilies = [...this.fundFamilies, ...res.families];
                        this.fundFamilies = this.fundFamilies.map(family => family = { value: family, label: family });
                        if (this.isZenith) {
                            this.fundFamilies.unshift({ label: this.$t('filter_by_fund_family'), value: '-1' })
                        }
                    }).catch(() => {
                        this.hasError = true;
                    })
            },

            reset() {
                this.$nextTick(() => {
                    this.hasError = false;
                    this.$refs.selectDrop.reset();
                    this.selected = this.isZenith ? '-1' : 'All';
                });
            },

            showFundFamily(selected) {
                this.selected = selected ? selected: this.defaultFundFamily;
                this.$emit('showFundFamily', this.selected);
            },

            initializeData() {
                return this.urlFilters && this.urlFilters.family ?
                    this.urlFilters.family : this.isZenith ? '-1' : 'All';
            }
        },

        mounted() {
            this.selected = this.initializeData();
            this.getFundFamilies();
            this.$emit('showFundFamily', this.selected);
        }
    }
</script>